export const reducer = ( state, action ) => {
	const result = action.payload;

	let filters = state.filters;
	let list;
	let index;

	switch ( action.type ) {

		case 'setCurrentPage':
			return {
				...state,
				currentPage: result
			}
		case 'setLoading':
			return {
				...state,
				loading: result
			}
		case 'setSortBy':
			return {
				...state,
				sortBy: result
			}
		case 'toggleMobileFiltersOpen':
			return {
				...state,
				mobileFiltersOpen: ! state.mobileFiltersOpen
			}
		case 'setSearchResults':
			const totalPages = Math.ceil( result.total / result.pageCount );

			return {
				...state,
				listings    : result.listings,
				listingCount: result.total,
				totalPages  : totalPages,
				page        : result.page
			}
		case 'clearFilters': 
			return {
				...state,
				filters: [],
				currentPage: 1,
			}
		case 'setFilter':
			filters[ result.field ] = result.value

			return {
				...state,
				filters: {...filters}
			}
		case 'removeFilter':
			if ( 'undefined' !== filters[ result ] ) {
				delete filters[ result ];
			}

			return {
				...state,
				filters: {...filters}
			}
		case 'addFilterToList':
			list = [];
			if ( 'undefined' !== typeof filters[ result.field ] ) {
				list = filters[ result.field ].split(',');
			}

			result.value.split(',').forEach( item => {
				list.push( item );
			})

			filters[ result.field ] = list.join(',');

			console.log({
				...state,
				filters: {...filters}
			})

			return {
				...state,
				filters: {...filters}
			}
		case 'removeFilterFromList':
			list = [];
			if ( 'undefined' !== typeof filters[ result.field ] ) {
				list = filters[ result.field ].split(',');
			}

			result.value.split(',').forEach( item => {
				if ( list.includes( item ) ) {
					index = list.indexOf( item );
	
					if ( index > -1 ) {
						list.splice( index, 1 );
					}
				}
			})

			filters[ result.field ] = list.join(',');

			if ( 'undefined' !== filters[ result.field ] && ! list.length ) {
				delete filters[ result.field ];
			}

			return {
				...state,
				filters: {...filters}
			}
	}
}